<template>
    <FormStep :title="appSettings.ElNetworkModuleStep1.Title" :stepNumber=1>
        <div class="electrictiy-bill-calculator__form-intro-container" v-if="appSettings.ElNetworkModuleStep1">
            <div class="electrictiy-bill-calculator__form-preamble" v-if="appSettings.ElNetworkModuleStep1 && appSettings.ElNetworkModuleStep1.Ingress" v-html="appSettings.ElNetworkModuleStep1.Ingress">
            </div>
        
            <read-more v-if="appSettings.ElNetworkModuleStep1.ReadMoreText" :button-text="appSettings.ElNetworkModuleStep1.ReadMoreButtonText" element-id="read-more-step-1">
                <p v-html="appSettings.ElNetworkModuleStep1.ReadMoreText">
                </p>
            </read-more>
        </div>

        <label class="is-visuallyhidden">Typ av kund</label>        
                
        <div class="electrictiy-bill-calculator__radios-container">
            <div v-for="aCustomerType in appSettings.CustomerTypeList" :key="aCustomerType.Id">                   
                <label class="electrictiy-bill-calculator__form-label" :for="'customerType'+aCustomerType.Id">
                    <input type="radio" name="customerType" :id="'customerType'+aCustomerType.Id" :value="aCustomerType.Id" v-model="customerType" required="required" />
                    {{aCustomerType.Name}}
                </label>
            </div>           
        </div>
        
    </FormStep>
</template>


<script setup>
    import FormStep from './FormStep.vue';
    import ReadMore from './ReadMore.vue';
    import { useWizardStore } from '../stores/WizardStore';
    import { storeToRefs } from "pinia";
    import { watch, computed } from 'vue'
    
    const store = useWizardStore()
    const { customerType, appSettings } = storeToRefs(store);
    
    const props = defineProps({});

    watch(customerType, (newVal, oldVal) => {
        if(newVal != oldVal) {
            store.resetFormDataThatDependsOnCustomerType();
        }
    })


</script>



<style scoped>

</style>
